"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeMobile = void 0;
var Home_1 = require("./mobile/Home");
Object.defineProperty(exports, "HomeMobile", { enumerable: true, get: function () { return Home_1.Home; } });
